/**
 * @description
 */

import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';
import { BusinessObjectIdType } from '@umu/umu-types';

interface IInput {
    parent_id: number;
    parent_type: BusinessObjectIdType;
    element_id?: number;
    element_data: string;
}

interface IOutput {
    element_id: number;
}

export const saveElement = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.SAVE_ELEMENT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

interface IChapterBindInput {
    session_id: number | string;
    chapter_id: string;
}
export const bindChapter = (data: IChapterBindInput): Promise<IResponse<{}>> => {
    return fetchData(Api.ELEMENT_BIND_CHAPTER, data);
};

export const saveElementSync = fetchDataSync<IInput>(saveElement);

interface ISaveSessionInput {
    group_id: number;
    session_data: string;
}

export const saveSession = (data: ISaveSessionInput): Promise<IResponse<{ session_id: string }>> => {
    return fetchData(Api.SAVE_SESSION, data).then((res: IResponse<{ session_id: string }>) => {
        return res;
    });
};
